module.exports = "/static/viewer/generated/images/Edar Icon.svg?df38748defd1b04452e73a4f6aeb5663";